import { useMemo } from 'react';
import type { SelectedIssue } from '../../controllers/merge-ideas-dialog/types.tsx';

export const useExcludedIssueIds = (selectedIssues: SelectedIssue[]): number[] =>
	useMemo(() => selectedIssues.map((selectedIssue) => selectedIssue.id), [selectedIssues]);
